import {
    COMPARADOR_LOAD_VERSIONS_BEGIN,
    COMPARADOR_LOAD_VERSIONS_FAILURE,
    COMPARADOR_LOAD_VERSIONS_SUCCESS
} from './constants'
import axios from 'axios'
import { getResponseVersionMapped } from '../utils/utils'

export function loadVersions(endpoint, inputValue, index) {
    return (dispatch, getState) => {
        if (!endpoint || index === undefined) {
            return null
        }

        const { comparador } = getState()
        const isUsed = !comparador.schema[index].dataSelected?.nuevo

        dispatch({ type: COMPARADOR_LOAD_VERSIONS_BEGIN })

        return new Promise((resolve, reject) => {
            const doRequest = axios.get(endpoint)
            doRequest.then(
                (res) => {
                    const responseData = getResponseVersionMapped(res.data.data, isUsed)
                    dispatch({
                        type: COMPARADOR_LOAD_VERSIONS_SUCCESS,
                        data: responseData,
                        index: index
                    })

                    let aux = res.data.data.filter((dataValue) => dataValue.name.includes(inputValue.toUpperCase()))
                    resolve(getResponseVersionMapped(aux, isUsed))
                },
                (err) => {
                    dispatch({
                        type: COMPARADOR_LOAD_VERSIONS_FAILURE,
                        data: { error: err },
                        index: index
                    })
                    reject(err)
                }
            )
        })
    }
}

export function reducer(state, action) {
    const { index, data, type } = action
    if (index === undefined) return state
    switch (type) {
        case COMPARADOR_LOAD_VERSIONS_BEGIN:
            return {
                ...state,
                versions: {
                    ...state.versions,
                    [`${index}`]: {
                        isPending: true,
                        hasError: null,
                        data: null
                    }
                }
            }

        case COMPARADOR_LOAD_VERSIONS_SUCCESS:
            return {
                ...state,
                versions: {
                    ...state.versions,
                    [`${index}`]: {
                        isPending: false,
                        hasError: null,
                        data: data
                    }
                }
            }

        case COMPARADOR_LOAD_VERSIONS_FAILURE:
            return {
                ...state,
                versions: {
                    ...state.versions,
                    [`${index}`]: {
                        isPending: false,
                        hasError: data.error,
                        data: null
                    }
                }
            }
        default:
            return state
    }
}

